export enum BlockType {
  text = "TEXT",
  image = "IMAGE",
  youtube = "VIDEO_YOUTUBE",
  file = "FILE",
}

export enum VISIBILITY {
  private = "PRIVATE",
  public = "PUBLIC",
}

export enum ELESSON_DETAIL {
  TEXT = "TEXT",
  IMAGE = "IMAGE",
  VIDEO_YOUTUBE = "VIDEO_YOUTUBE",
  LINK = "LINK",
  FILE = "FILE",
}

export enum QUIZ_QUERY_KEYS {
  LIST = "quiz_list",
  DETAIL = "quiz_detail",
  DONE_LIST = "done_quiz_list",
  DONE_DETAIL = "done_quiz_detail",
  DONE_CATEGORY_LIST = "done_quiz_category_list",
  RELATED_QUIZ_LIST = "related_quiz_list",
  CATEGORY_LIST = "quiz_category_list",
}

export enum EVISIBILITY {
  PRIVATE = "PRIVATE",
  PUBLIC = "PUBLIC",
}

export enum ESTATUS_LEARNING {
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
}

export enum NOTIFICATION_QUERY_KEYS {
  ALL_NOTIFICATIONS = "all_notifications",
  NOTIFICATION_BY_ID = "notification_by_id",
  DELETE_NOTIFICATION = "delete_notification",
  UNREAD_COUNT = "unread_count",
  MY_NOTIFICATIONS = "my_notifications",
  MARK_AS_READ = "mark_as_read",
  MARK_ALL_AS_READ = "mark_all_as_read",
  MY_DETAIL = "my_noti_detail",
  CREATE = "create_notification",
  CREATE_DRAFT = "create_draft",
  UPDATE = "update_notification",
  UPDATE_DRAFT = "update_draft_notification",
  GET_MY_NOTIFICATION_BY_PAGES = "get_my_notification_by_pages",
}

export enum STORES_QUERY_KEYS {
  GET_STORES_MY_COMPANY = "get_stores_my_company",
  GET_STORE_MY_USERS = "get_store_my_users",
}

export enum STORE_GROUPS_QUERY_KEYS {
  GET_STORE_GROUPS_MY_COMPANY = "get_store_groups_my_company",
}

export enum ERESULT {
  PASSED = "PASSED",
  FAILED = "FAILED",
}

export enum COMMON_STATUS {
  ENABLE = "ENABLE",
  DISABLE = "DISABLE",
}

export enum RoleEnum {
  SUPER_ADMIN = "super",
  COMPANY_ADMIN = "admin",
  HEAD_OFFICE_USER = "head",
  STORE_MANAGER = "store",
  USER = "user",
  OTHER = "other",
}

export const RoleManagerExcute = {
  COMPANY: {
    VIEW: {
      [RoleEnum.SUPER_ADMIN]: true,
      [RoleEnum.COMPANY_ADMIN]: true,
      [RoleEnum.HEAD_OFFICE_USER]: true,
      [RoleEnum.STORE_MANAGER]: false,
      [RoleEnum.USER]: false,
      [RoleEnum.OTHER]: false,
    },
    UPDATE: {
      [RoleEnum.SUPER_ADMIN]: true,
      [RoleEnum.COMPANY_ADMIN]: true,
      [RoleEnum.HEAD_OFFICE_USER]: false,
      [RoleEnum.STORE_MANAGER]: false,
      [RoleEnum.USER]: false,
      [RoleEnum.OTHER]: false,
    },
    ACTIVE: {
      [RoleEnum.SUPER_ADMIN]: true,
      [RoleEnum.COMPANY_ADMIN]: false,
      [RoleEnum.HEAD_OFFICE_USER]: false,
      [RoleEnum.STORE_MANAGER]: false,
      [RoleEnum.USER]: false,
      [RoleEnum.OTHER]: false,
    },
  },
  GROUP: {
    CREATE: {
      [RoleEnum.SUPER_ADMIN]: true,
      [RoleEnum.COMPANY_ADMIN]: true,
      [RoleEnum.HEAD_OFFICE_USER]: false,
      [RoleEnum.STORE_MANAGER]: false,
      [RoleEnum.USER]: false,
      [RoleEnum.OTHER]: false,
    },
    VIEW: {
      [RoleEnum.SUPER_ADMIN]: true,
      [RoleEnum.COMPANY_ADMIN]: true,
      [RoleEnum.HEAD_OFFICE_USER]: true,
      [RoleEnum.STORE_MANAGER]: false,
      [RoleEnum.USER]: false,
      [RoleEnum.OTHER]: false,
    },
    UPDATE: {
      [RoleEnum.SUPER_ADMIN]: true,
      [RoleEnum.COMPANY_ADMIN]: true,
      [RoleEnum.HEAD_OFFICE_USER]: false,
      [RoleEnum.STORE_MANAGER]: false,
      [RoleEnum.USER]: false,
      [RoleEnum.OTHER]: false,
    },
    ACTIVE: {
      [RoleEnum.SUPER_ADMIN]: true,
      [RoleEnum.COMPANY_ADMIN]: true,
      [RoleEnum.HEAD_OFFICE_USER]: false,
      [RoleEnum.STORE_MANAGER]: false,
      [RoleEnum.USER]: false,
      [RoleEnum.OTHER]: false,
    },
    MOVING: {
      [RoleEnum.SUPER_ADMIN]: true,
      [RoleEnum.COMPANY_ADMIN]: true,
      [RoleEnum.HEAD_OFFICE_USER]: false,
      [RoleEnum.STORE_MANAGER]: false,
      [RoleEnum.USER]: false,
      [RoleEnum.OTHER]: false,
    },
  },
  STORE: {
    CREATE: {
      [RoleEnum.SUPER_ADMIN]: true,
      [RoleEnum.COMPANY_ADMIN]: true,
      [RoleEnum.HEAD_OFFICE_USER]: true,
      [RoleEnum.STORE_MANAGER]: false,
      [RoleEnum.USER]: false,
      [RoleEnum.OTHER]: false,
    },
    VIEW: {
      [RoleEnum.SUPER_ADMIN]: true,
      [RoleEnum.COMPANY_ADMIN]: true,
      [RoleEnum.HEAD_OFFICE_USER]: true,
      [RoleEnum.STORE_MANAGER]: true,
      [RoleEnum.USER]: false,
      [RoleEnum.OTHER]: false,
    },
    UPDATE: {
      [RoleEnum.SUPER_ADMIN]: true,
      [RoleEnum.COMPANY_ADMIN]: true,
      [RoleEnum.HEAD_OFFICE_USER]: true,
      [RoleEnum.STORE_MANAGER]: true,
      [RoleEnum.USER]: false,
      [RoleEnum.OTHER]: false,
    },
    ACTIVE: {
      [RoleEnum.SUPER_ADMIN]: true,
      [RoleEnum.COMPANY_ADMIN]: true,
      [RoleEnum.HEAD_OFFICE_USER]: true,
      [RoleEnum.STORE_MANAGER]: false,
      [RoleEnum.USER]: false,
      [RoleEnum.OTHER]: false,
    },
  },
  USER_IN_COMPANY: {
    CREATE: {
      [RoleEnum.SUPER_ADMIN]: true,
      [RoleEnum.COMPANY_ADMIN]: true,
      [RoleEnum.HEAD_OFFICE_USER]: false,
      [RoleEnum.STORE_MANAGER]: false,
      [RoleEnum.USER]: false,
      [RoleEnum.OTHER]: false,
    },
    VIEW: {
      [RoleEnum.SUPER_ADMIN]: true,
      [RoleEnum.COMPANY_ADMIN]: true,
      [RoleEnum.HEAD_OFFICE_USER]: true,
      [RoleEnum.STORE_MANAGER]: false,
      [RoleEnum.USER]: false,
      [RoleEnum.OTHER]: false,
    },
    UPDATE: {
      [RoleEnum.SUPER_ADMIN]: true,
      [RoleEnum.COMPANY_ADMIN]: false,
      [RoleEnum.HEAD_OFFICE_USER]: false,
      [RoleEnum.STORE_MANAGER]: false,
      [RoleEnum.USER]: false,
      [RoleEnum.OTHER]: false,
    },
    ACTIVE: {
      [RoleEnum.SUPER_ADMIN]: true,
      [RoleEnum.COMPANY_ADMIN]: true,
      [RoleEnum.HEAD_OFFICE_USER]: false,
      [RoleEnum.STORE_MANAGER]: false,
      [RoleEnum.USER]: false,
      [RoleEnum.OTHER]: false,
    },
  },
  USER_IN_STORE: {
    CREATE: {
      [RoleEnum.SUPER_ADMIN]: true,
      [RoleEnum.COMPANY_ADMIN]: true,
      [RoleEnum.HEAD_OFFICE_USER]: true,
      [RoleEnum.STORE_MANAGER]: true,
      [RoleEnum.USER]: false,
      [RoleEnum.OTHER]: false,
    },
    VIEW: {
      [RoleEnum.SUPER_ADMIN]: true,
      [RoleEnum.COMPANY_ADMIN]: true,
      [RoleEnum.HEAD_OFFICE_USER]: true,
      [RoleEnum.STORE_MANAGER]: true,
      [RoleEnum.USER]: false,
      [RoleEnum.OTHER]: false,
    },
    UPDATE: {
      [RoleEnum.SUPER_ADMIN]: true,
      [RoleEnum.COMPANY_ADMIN]: true,
      [RoleEnum.HEAD_OFFICE_USER]: true,
      [RoleEnum.STORE_MANAGER]: true,
      [RoleEnum.USER]: false,
      [RoleEnum.OTHER]: false,
    },
    ACTIVE: {
      [RoleEnum.SUPER_ADMIN]: true,
      [RoleEnum.COMPANY_ADMIN]: true,
      [RoleEnum.HEAD_OFFICE_USER]: true,
      [RoleEnum.STORE_MANAGER]: true,
      [RoleEnum.USER]: false,
      [RoleEnum.OTHER]: false,
    },
    MOVING: {
      [RoleEnum.SUPER_ADMIN]: true,
      [RoleEnum.COMPANY_ADMIN]: true,
      [RoleEnum.HEAD_OFFICE_USER]: true,
      [RoleEnum.STORE_MANAGER]: false,
      [RoleEnum.USER]: false,
      [RoleEnum.OTHER]: false,
    },
  },
  ELEARNING_LESSON: {
    VIEW: {
      [RoleEnum.SUPER_ADMIN]: true,
      [RoleEnum.COMPANY_ADMIN]: true,
      [RoleEnum.HEAD_OFFICE_USER]: true,
      [RoleEnum.STORE_MANAGER]: true,
      [RoleEnum.USER]: true,
      [RoleEnum.OTHER]: false,
    },
  },
  ELEARNING_QUIZ: {
    VIEW: {
      [RoleEnum.SUPER_ADMIN]: true,
      [RoleEnum.COMPANY_ADMIN]: true,
      [RoleEnum.HEAD_OFFICE_USER]: true,
      [RoleEnum.STORE_MANAGER]: true,
      [RoleEnum.USER]: true,
      [RoleEnum.OTHER]: false,
    },
  },
  USER_LEARNING: {
    VIEW: {
      [RoleEnum.SUPER_ADMIN]: true,
      [RoleEnum.COMPANY_ADMIN]: true,
      [RoleEnum.HEAD_OFFICE_USER]: true,
      [RoleEnum.STORE_MANAGER]: true,
      [RoleEnum.USER]: true,
      [RoleEnum.OTHER]: false,
    },
  },
  USER_INFORMATION: {
    VIEW: {
      [RoleEnum.SUPER_ADMIN]: true,
      [RoleEnum.COMPANY_ADMIN]: true,
      [RoleEnum.HEAD_OFFICE_USER]: true,
      [RoleEnum.STORE_MANAGER]: true,
      [RoleEnum.USER]: true,
      [RoleEnum.OTHER]: false,
    },
  },
};

export const PriorityRole = {
  [RoleEnum.SUPER_ADMIN]: 6,
  [RoleEnum.COMPANY_ADMIN]: 5,
  [RoleEnum.HEAD_OFFICE_USER]: 4,
  [RoleEnum.STORE_MANAGER]: 3,
  [RoleEnum.USER]: 2,
  [RoleEnum.OTHER]: 1,
};

export enum CHECK_STORE_STATUS {
  NOTIFIED = "NOTIFIED",
  DRAFT = "DRAFT",
}

export enum ECHAT_THEME_TYPE {
  M = "M",
  D = "D",
  CS = "CS",
  TS = "TS",
  OTHERS = "他",
}

export const ECHAT_THEME_LABEL = {
  [ECHAT_THEME_TYPE.M]: "M（メーカー）",
  [ECHAT_THEME_TYPE.D]: "D（卸会社）",
  [ECHAT_THEME_TYPE.CS]: "CS（カーショップ）",
  [ECHAT_THEME_TYPE.TS]: "TS（タイヤ専門店）",
  [ECHAT_THEME_TYPE.OTHERS]: "その他",
}

export enum ECHAT_THEME {
  FLYERS_ETC = "チラシ等",
  POPS = "POP類",
  WEB = "ウェブ",
  OTHERS = "その他",
}

export enum CHAT_ARTICLE_TYPE {
  第2条 = "第2条",
  第5条 = "第5条",
  第6条 = "第6条",
  第7条 = "第7条",
  第8条 = "第8条",
  第9条 = "第9条",
  第10条 = "第10条",
  第11条 = "第11条",
  第13条 = "第13条",
  第14条 = "第14条",
  他景品 = "他景品",
  規約 = "規約",
  独禁法 = "独禁法",
}

// 📁 MimeType.ts
export enum MimeType {
  // Documents
  PDF = "application/pdf",
  DOCX = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  RTF = "application/rtf",
  TXT = "text/plain",
  MD = "text/markdown",

  // Spreadsheets
  XLSX = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  CSV = "text/csv",

  // Images
  JPEG = "image/jpeg",
  PNG = "image/png",
  GIF = "image/gif",
  WEBP = "image/webp",
  SVG = "image/svg+xml",
  JPG = "image/jpg",

  // Videos
  MP4 = "video/mp4",
  MOV = "video/quicktime",
  MKV = "video/x-matroska",
  WEBM = "video/webm",

  // Audio
  MP3 = "audio/mpeg",
  WAV = "audio/wav",
  FLAC = "audio/flac",

  // Archives
  ZIP = "application/zip",
  RAR = "application/vnd.rar",
  SEVEN_Z = "application/x-7z-compressed",

  // Code
  JS = "application/javascript",
  TS = "application/typescript",
  HTML = "text/html",
  CSS = "text/css",
  JSON = "application/json",
  PY = "text/x-python",
  JAVA = "text/x-java-source",
  SQL = "application/sql",

  // System / Executable
  EXE = "application/vnd.microsoft.portable-executable",
  APK = "application/vnd.android.package-archive",
  DMG = "application/x-apple-diskimage",

  // Others
  LOG = "text/plain",
  ENV = "text/plain",
  EPUB = "application/epub+zip",

  // word, excel, powerpoint mime types
  DOC = "application/msword",
  XLS = "application/vnd.ms-excel",
  PPT = "application/vnd.ms-powerpoint",
  PPTX = "application/vnd.openxmlformats-officedocument.presentationml.presentation",
}

export enum ESendMessageType {
  TEXT = "text",
  STICKER = "sticker",
  FILES = "files",
}

export enum CHAT_STATUS {
  未対応 = "未対応",
  対応中 = "対応中",
  対応済 = "対応済",
}

export enum CHAT_QUERY_KEYS {
  ALL_CHATS = "all_chats",
  CHAT_BY_ID = "chat_by_id",
  CREATE_CHAT = "create_chat",
  UPDATE_CHAT = "update_chat",
  DELETE_CHAT = "delete_chat",
  CHAT_MESSAGES = "chat_messages",
  MASTER_DATA = "chat_master_data", // LIST OF DEFAULT MESSAGE TEMPLATES
  GET_LIST_CHAT_MEMBERS = "get_list_chat_members",
  GET_VIEWER = "get_chat_viewer",
  CHANGE_USER = "change_chat_user",
  ADD_MEMBER = "add_chat_member",
}

export enum SOCKET_EVENTS {
  CONNECT = "connect",
  DISCONNECT = "disconnect",
  ERROR = "connect_error",
  JOIN_ROOM = "join", // emit join room with roomId
  SEND_MESSAGE = "send_message", // emit send text message
  SEND_FILE = "send_file", // emit send file
  NEW_MESSAGE = "new_message", // message return when a new message is sent
  GET_USERS_IN_ROOM = "get_users_in_room", // emit event to get list of users in room
  USER_JOINED = "user_joined", // message return when a user joins the room
  USERS_IN_ROOM = "users_in_room", // message return when emit event get users in room
  DELETE_MESSAGE = "delete_message", // emit delete message
  EDIT_MESSAGE = "edit_message", // emit edit message
  MESSAGE_DELETED = "message_deleted", // message return when a message is deleted
  MESSAGE_EDITED = "message_edited", // message return when a message is edited
  LEAVE_ROOM = "leave_room", // emit leave room with roomId
  PUBLISH_MESSAGE = "publish_message", // listen new message in public event
  USER_LEFT = "user_left", // message return when a user leaves the room
}

export enum CHAT_ROLE {
  // only view message
  MEMBER = "MEMBER",
  // incharge can send message / edit info / add member
  INCHARGE = "INCHARGE",
}
